import { FC } from 'react';
import { Image, ImageProps } from '@chakra-ui/react';

import HeartBox from './assets/HeartBox@2x.png';

const ApplicationProblemImage: FC<ImageProps> = (props) => (
  <Image
    boxSize="180px"
    marginBottom="space-16"
    marginX="auto"
    src={HeartBox}
    {...props}
  />
);

export default ApplicationProblemImage;
